<template>
	<div class="sticky-header">
		<div style="flex: 0.2"></div>
		<img class="logo"
			src="@/assets/logo.png" />
		<div style="flex: 0.5"></div>
		<div class="right-box">
			<div class="right-box-item"
				:class="{ 'right-box-item-active': active === index }"
				v-for="(item, index) in itemList"
				:key="index"
				@click="handleItme(index)">
				{{ item.title }}
			</div>
		</div>
		<div style="flex: 0.5"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				itemList: [{
						title: '首页',
						path: '/home'
					},
					{
						title: '关于我们',
						path: '/about'
					},
					{
						title: '产品中心',
						path: '/products'
					},
					{
						title: '合作伙伴',
						path: '/partners'
					},
					{
						title: '联系我们',
						path: '/contact'
					}
				],
				active: 0
			}
		},
		methods: {
			/**
			 * 切换
			 */
			handleItme(index) {
				const item = this.itemList[index]
				this.$router.push({
					path: item.path
				})
			}
		},
		mounted() {

		},
		watch: {
			'$route.path': {
				deep: true,
				handler(val) {
					const index = this.itemList.findIndex((item) =>
						item.path === val)
					if (index >= 0) {
						this.active = index
					}
				}
			}
		}
	}
</script>

<style lang="scss"
	scoped>
	.sticky-header {
		position: sticky;
		top: 0;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(5px);
		z-index: 1000;
		border-bottom: 1px solid #eee;
		transition: all 0.3s;
		height: 70px;

		display: flex;
		align-items: center;
	}

	.ticky-header-shadow {
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	}

	.logo {
		width: 190px;
		height: 40px;
	}

	.right-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 400px;
		min-width: 300px;
	}

	.right-box-item {
		flex-shrink: 0;
		cursor: pointer;
		font-weight: bold;

		&:last-of-type {
			margin-right: 0px;
		}

		&:hover {
			transform: scale(1.2);
		}
	}

	.right-box-item-active {
		color: #5ac4ff;
	}
</style>